export default __webpack_public_path__ + "static/article3-d14dffafda42442d6bfa391da1a63c00.png";